<div class="l-match">
    @if (match.showDate) {
        <div class="match-date">
            {{ match.createdAt | luxon: 'DATE_HUGE' }}
        </div>
    }
    @if (match.startedAt) {
        <div class="dashboard_time text-muted">
            {{ match.startedAt | luxon: 'TIME_SIMPLE' }} - {{ match.endedAt | luxon: 'TIME_SIMPLE' }}
        </div>
    } @else {
        <div class="match-time text-muted">{{ match.createdAt | luxon: 'TIME_SIMPLE' }}</div>
    }
    <ng-template #emptyAvatar>
        <div class="avatar"></div>
    </ng-template>

    @if (match.settings.gameMode === gameMode.OneAgainstOne) {
        <app-match-box-header-one-against-one [match]="match"></app-match-box-header-one-against-one>
    }
    @if (match.settings.gameMode === gameMode.TwoAgainstTwo) {
        <app-match-box-header-two-against-two [match]="match"></app-match-box-header-two-against-two>
    }

    <div class="l-score" (dblclick)="matchClick(match)">
        @for (ma of match.sets; track ma; let setIx = $index) {
            <div class="score" [class.clickable]="ma.goals" [class.selected]="setIx === selectedSet" (click)="selectSet(setIx)">
                <div class="score_numbers" [class.shame]="ma.scoreTeamA === 0 || ma.scoreTeamB === 0">
                    <span class="count score" [class.dark]="ma.scoreTeamA > ma.scoreTeamB">{{ ma.scoreTeamA }}</span>
                    <div class="colon-small">:</div>
                    <span class="count score" [class.dark]="ma.scoreTeamA < ma.scoreTeamB">{{ ma.scoreTeamB }}</span>
                </div>
            </div>
        }
    </div>
    <div class="comments">
        <div class="header">
            <mat-icon
                (mouseenter)="hoveredEmoji = matchEmojiType.ThumbsUp"
                (mouseleave)="hoveredEmoji = null"
                class="clickable mt-3 mx-2"
                [class.active]="isEmojiActive(matchEmojiType.ThumbsUp)"
                (click)="onEmojiClick($event, matchEmojiType.ThumbsUp)"
                [matBadge]="getEmojiCount(matchEmojiType.ThumbsUp)"
                [matBadgeHidden]="getEmojiCount(matchEmojiType.ThumbsUp) === 0"
                [matTooltip]="'MATCHBOX.THUMBS_UP' | translate"
                [matTooltipPosition]="'above'"
                >thumb_up
            </mat-icon>
            <mat-icon
                (mouseenter)="hoveredEmoji = matchEmojiType.ThumbsDown"
                (mouseleave)="hoveredEmoji = null"
                class="clickable mt-3 mx-2"
                [class.active]="isEmojiActive(matchEmojiType.ThumbsDown)"
                (click)="onEmojiClick($event, matchEmojiType.ThumbsDown)"
                [matBadge]="getEmojiCount(matchEmojiType.ThumbsDown)"
                [matBadgeHidden]="getEmojiCount(matchEmojiType.ThumbsDown) === 0"
                [matTooltip]="'MATCHBOX.THUMBS_DOWN' | translate"
                [matTooltipPosition]="'above'"
                >thumb_down</mat-icon
            >
            <mat-icon
                (click)="onCommentsClick()"
                class="clickable mt-3 mx-2"
                [matBadge]="match.commentsCount"
                [matBadgeHidden]="!match.comments.length"
                [matTooltip]="'MATCHBOX.COMMNETS' | translate"
                [matTooltipPosition]="'above'"
                >comment</mat-icon
            >
            @if (match.achievements.length) {
                <mat-icon
                    (click)="onAchievementsClick()"
                    class="clickable mt-3 mx-2"
                    [matBadge]="match.achievements.length"
                    [matTooltip]="'MATCHBOX.ACHIEVEMENTS' | translate"
                    [matTooltipPosition]="'above'"
                    >emoji_events</mat-icon
                >
            }
            <mat-icon
                class="clickable mt-3 mx-2"
                [matMenuTriggerFor]="menu"
                [matTooltip]="'MATCHBOX.SETTINGS' | translate"
                [matTooltipPosition]="'above'"
                >settings</mat-icon
            >
            <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="editMatch()" [disabled]="!canEdit">
                    <mat-icon>edit</mat-icon>
                    <span>{{ 'MATCHBOX.SETTINGS_EDIT' | translate }}</span>
                </button>
                <button mat-menu-item [swal]="deleteMatchSwal" [disabled]="!canEdit">
                    <mat-icon>delete</mat-icon>
                    <span>{{ 'MATCHBOX.SETTINGS_DELETE' | translate }}</span>
                </button>
            </mat-menu>
            <swal
                #deleteMatchSwal
                [title]="'MATCHBOX.DELETE_MATCH_TITLE' | translate"
                [text]="'MATCHBOX.DELETE_MATCH_TEXT' | translate"
                [showCancelButton]="true"
                [cancelButtonText]="'COMMON.CANCEL' | translate"
                [confirmButtonText]="'COMMON.CONFIRM' | translate"
                [confirmButtonColor]="'#96242f'"
                [icon]="'question'"
                (confirm)="deleteMatch()"
            >
            </swal>
        </div>
    </div>
    @if (hoveredEmoji) {
        <div class="comments text-center" [@fasterToggleAnimation]>{{ getEmojiPlayers(hoveredEmoji) }}</div>
    }
    @if (!showComments && match.sets[selectedSet]?.goals?.length) {
        <h4 class="my-3">
            {{ 'DASHBOARD.MATCHBOX_SET_SET' | translate: { set: selectedSet + 1 } }}
        </h4>
    }
    @if (!showComments && match.sets[selectedSet]?.goals?.length) {
        <app-match-box-goals
            style="width: 100%; max-width: 600px"
            [@toggleAnimation]
            [match]="match"
            [selectedSet]="selectedSet"
        ></app-match-box-goals>
    }

    @if (showAchievements) {
        <app-match-box-achievements style="width: 100%; max-width: 600px" [achievements]="match.achievements" [@toggleAnimation]>
        </app-match-box-achievements>
    }
    @if (showComments) {
        <div class="comments-container" [@toggleAnimation]>
            @for (comment of match.comments; track comment) {
                <div class="my-2">
                    <app-comment [comment]="comment" [level]="0"></app-comment>
                </div>
            }
            <app-upsert-comment [focusOnInit]="match.comments.length === 0" [idMatch]="match.id" class="m-2 p-2"></app-upsert-comment>
        </div>
    }
</div>
